import { KewnetStatus } from 'app/constants';

const REACTIVABLE_FINAL_STATUS_IDS = new Set<number>([
  KewnetStatus.delivered,
  KewnetStatus.closed,
  KewnetStatus.finalProcessing,
  KewnetStatus.waitingForClient,
  KewnetStatus.waitingInStockel,
  KewnetStatus.waitingInLeuze,
  KewnetStatus.waitingInLiege,
  KewnetStatus.waitingInAntwerpen,
  KewnetStatus.standby,
  KewnetStatus.managed,
]);

const FINAL_STATUS_NAME_PATTERNS = [
  'clotur',
  'clôtur',
  'livr',
  'enlev',
  'enlèv',
  'expedi',
  'expédi',
  'termine',
  'terminé',
];

export const isReactivableFinalStatus = (
  statusId?: number,
  statusName?: string,
): boolean => {
  if (statusId === undefined) return false;

  if (statusId === KewnetStatus.inProgress) return false;

  if (REACTIVABLE_FINAL_STATUS_IDS.has(statusId)) return true;

  if (!statusName) return false;

  const normalizedStatusName = statusName.toLowerCase();
  return FINAL_STATUS_NAME_PATTERNS.some(pattern =>
    normalizedStatusName.includes(pattern),
  );
};
